import { designTokens } from '@project44/manifest-ds';

export const LoginFormWrapper = {
  display: 'flex',
  flexDirection: 'column',
  background: designTokens.colorBackgroundPrimary,
  borderRadius: designTokens.radiusSmall,

  '@media (min-width: 500px)': {
    padding: '56px 40px',
    width: '488px',
    maxWidth: '488px',
  },
  '@media (max-width: 500px)': {
    padding: `48px ${designTokens.spaceXLarge}`,
    width: '100%',
    maxWidth: '100%',
  },
};

export const LoginWrapper = {
  zIndex: '100',
  height: '100%',
  flexDirection: 'column',
  width: '50%',
  '@media (max-width: 500px)': {
    width: '100%',
    maxWidth: '100%',
    backgroundColor: designTokens.colorBackgroundPrimary,
    justifyContent: 'space-between',
  },
  '@media (max-width: 360px)': {
    overflow: 'auto',
  },
};

export const BackgroundVideoWrapper = {
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  zIndex: 10,
  width: '50%',
  height: '100%',
  background: '#131313',
  '@media (max-width: 1024px)': { display: 'none' },
  video: {
    mixBlendMode: 'lighten',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    objectFit: 'none',
  },
};

export const LoginPageWrapper = {
  height: '100vh',
  width: '100vw',
  maxHeight: 'fit-content',
  background: '#131313',
  '@media (max-width: 500px)': {
    padding: designTokens.spaceMedium,
  },
  '@media (max-width: 1024px)': {
    justifyContent: 'center',
  },
};
